import type { AgenticAiState } from "@lib/agenticAi";

import { useAgenticAiSelector } from "@services/useAgenticAiSelector";

const selectIsOpen = (state: AgenticAiState): boolean => state.isOpen;

export const useIsAgenticAiChatOpen = (): boolean => {
  return useAgenticAiSelector(selectIsOpen);
};
